import { ComboBoxStatus, UserCategory, Vehicle } from '@core/models/swagger';
import { InitFlow } from '@core/models/swagger/initFlow';
import { Quoting } from '@core/models/swagger/quoting';
import { Recommendation } from '@core/models/swagger/recommendation';
import { VehicleSelection } from '@core/models/swagger/vehicleSelection';
import { QbItaParameterResult } from '@fwmovilidad/qb-home-ita-components-lib';
import { PreviousInsuranceFinishEnum, QuestionEnum } from '@global/enums';
import { createAction, props } from '@ngrx/store';

export enum GeneralActions {
  ResetGeneral = '[Flow Data General] Reset general',
  UpdateVehicleSelection = '[Flow Data General] Update Vehicle Selection',
  UpdateUploadedImage = '[Flow Data General] Update Uploaded Image',
  UpdateBrand = '[Flow Data General] Update Brand',
  UpdateManufactureYear = '[Flow Data General] Update Manufacture Year',
  UpdateModel = '[Flow Data General] Update Model',
  UpdateFuel = '[Flow Data General] Update Fuel',
  UpdateCarType = '[Flow Data General] Update Car Type',
  UpdateHorsePower = '[Flow Data General] Update Horse Power',
  UpdatePossibleVehicles = '[Flow Data General] Update Possible Vehicles',
  UpdateSelectedVehicle = '[Flow Data General] Update Selected Vehicle',
  UpdatePrevUrl = '[Flow Data General] Update previouse url',
  UpdateInsurerTakerCategory = '[Flow Data General] Update Insurer Taker Category Vehicle',
  UpdateOtherVehicles = '[Flow Data General] Update Other Vehicles',
  UpdateCorrelationId = '[Flow Data General] Update correlation id',
  UpdateInitFlowParameters = '[Flow Data General] Update init flow parameters',
  UpdatePriceInfo = '[Flow Data General] Update flow data info',
  UpdateInitFlowData = '[Flow Data General] Update init flow data',
  UpdateBankAccountHolderAuthorization = '[Flow Data General] Update bank account holder authorization',
  UpdateVehicleOwnerCategory = '[Flow Data General] Update vehicle owner category',
  UpdateBankAccountHolderCategory = '[Flow Data General] Update bank account holder category',
  UpdatePreviousInsuranceFinish = '[Flow Data General] Update previous insurance finish',
  UpdateHasPreviousClaims = '[Flow Data General] Update has previous claims',
  UpdateGapSelection = '[Flow Data General] Update GAP selection',
  UpdatePostcode = '[Flow Data General] Update postcode',
  UpdateDeductibleOptions = '[Flow Data General] Update deductible options',
  UpdatePaymentMethods = '[Flow Data General] Update payment methods',
  UpdateProgressId = '[Flow Data General] Update progress id',
  UpdateFullOperationId = '[Flow Data General] Update full operation id',
  UpdateInsuranceModalitiesOffered = '[Flow Data General] Update insurance modalities offered',
  UpdateInsurancePricesOffered = '[Flow Data General] Update insurance prices offered',
  UpdatePreviousInsuranceBrand = '[Flow Data General] Update cancel reason',
  UpdateDefaultPrice = '[Flow Data General] Update default price',
  UpdateAddonNamesSelected = '[Flow Data General] Update addon names selected',
  UpdateAddonPricesSelected = '[Flow Data General] Update addon prices selected',
  UpdateAnalyticBrand = '[Flow Data General] Update analytic brand',
  UpdateAnalyticModel = '[Flow Data General] Update analytic model',
  UpdateReferralCodeUrl = '[Flow Data General] Update referralCodeUrl',
  UpdateLastPromotionCodeValidated = '[Flow Data General] Update last promotion code validated',
  UpdateVehicleDoors = '[Flow Data General] Update vehicle doors number',
  UpdateRecommendations = '[Flow Data General] Update recommendations',
  UpdateQuotation = '[Flow Data General] Update quotation',
  UpdateCarInsurers = '[Flow Data General] Update car insurers',
}

export const ResetGeneral = createAction(GeneralActions.ResetGeneral);

export const UpdateVehicleSelection = createAction(
  GeneralActions.UpdateVehicleSelection,
  props<{ data: VehicleSelection }>()
);

export const UpdateUploadedImage = createAction(GeneralActions.UpdateUploadedImage, props<{ data: string }>());

export const UpdateBrand = createAction(GeneralActions.UpdateBrand, props<{ data: ComboBoxStatus }>());

export const UpdateManufactureYear = createAction(
  GeneralActions.UpdateManufactureYear,
  props<{ data: ComboBoxStatus }>()
);

export const UpdateModel = createAction(GeneralActions.UpdateModel, props<{ data: ComboBoxStatus }>());

export const UpdateFuel = createAction(GeneralActions.UpdateFuel, props<{ data: ComboBoxStatus }>());

export const UpdateCarType = createAction(GeneralActions.UpdateCarType, props<{ data: ComboBoxStatus }>());

export const UpdateHorsePower = createAction(GeneralActions.UpdateHorsePower, props<{ data: ComboBoxStatus }>());

export const UpdatePossibleVehicles = createAction(GeneralActions.UpdatePossibleVehicles, props<{ data: Vehicle[] }>());

export const UpdateSelectedVehicle = createAction(GeneralActions.UpdateSelectedVehicle, props<{ data: number }>());

export const UpdatePrevUrl = createAction(GeneralActions.UpdatePrevUrl, props<{ data: string }>());

export const UpdateInsurerTakerCategory = createAction(
  GeneralActions.UpdateInsurerTakerCategory,
  props<{ data: UserCategory }>()
);

export const UpdateOtherVehicles = createAction(GeneralActions.UpdateOtherVehicles, props<{ data: boolean }>());

export const UpdatePriceInfo = createAction(GeneralActions.UpdatePriceInfo, props<{ data: any }>());

export const UpdateInitFlowData = createAction(GeneralActions.UpdateInitFlowData, props<{ data: InitFlow }>());

export const UpdateBankAccountHolderAuthorization = createAction(
  GeneralActions.UpdateBankAccountHolderAuthorization,
  props<{ data: boolean }>()
);

export const UpdateVehicleOwnerCategory = createAction(
  GeneralActions.UpdateVehicleOwnerCategory,
  props<{ data: UserCategory }>()
);

export const UpdateBankAccountHolderCategory = createAction(
  GeneralActions.UpdateBankAccountHolderCategory,
  props<{ data: UserCategory }>()
);

export const UpdatePreviousInsuranceFinish = createAction(
  GeneralActions.UpdatePreviousInsuranceFinish,
  props<{ data: PreviousInsuranceFinishEnum }>()
);

export const UpdateHasPreviousClaims = createAction(
  GeneralActions.UpdateHasPreviousClaims,
  props<{ data: QuestionEnum }>()
);

export const UpdateGapSelection = createAction(GeneralActions.UpdateGapSelection, props<{ data: boolean }>());

export const UpdatePostcode = createAction(GeneralActions.UpdatePostcode, props<{ data: string }>());

export const UpdateDeductibleOptions = createAction(
  GeneralActions.UpdateDeductibleOptions,
  props<{ data: QbItaParameterResult }>()
);

export const UpdatePaymentMethods = createAction(
  GeneralActions.UpdatePaymentMethods,
  props<{ data: QbItaParameterResult }>()
);

export const UpdateProgressId = createAction(GeneralActions.UpdateProgressId, props<{ data: number }>());

export const UpdateFullOperationId = createAction(GeneralActions.UpdateFullOperationId, props<{ data: string }>());

export const UpdateInsuranceModalitiesOffered = createAction(
  GeneralActions.UpdateInsuranceModalitiesOffered,
  props<{ data: string }>()
);

export const UpdateInsurancePricesOffered = createAction(
  GeneralActions.UpdateInsurancePricesOffered,
  props<{ data: string }>()
);

export const UpdatePreviousInsuranceBrand = createAction(
  GeneralActions.UpdatePreviousInsuranceBrand,
  props<{ data: string }>()
);

export const UpdateDefaultPrice = createAction(GeneralActions.UpdateDefaultPrice, props<{ data: string }>());

export const UpdateAddonNamesSelected = createAction(
  GeneralActions.UpdateAddonNamesSelected,
  props<{ data: string }>()
);

export const UpdateAddonPricesSelected = createAction(
  GeneralActions.UpdateAddonPricesSelected,
  props<{ data: string }>()
);

export const UpdateAnalyticBrand = createAction(GeneralActions.UpdateAnalyticBrand, props<{ data: string }>());

export const UpdateAnalyticModel = createAction(GeneralActions.UpdateAnalyticModel, props<{ data: string }>());

export const UpdateReferralCodeUrl = createAction(GeneralActions.UpdateReferralCodeUrl, props<{ data: string }>());

export const UpdateLastPromotionCodeValidated = createAction(
  GeneralActions.UpdateLastPromotionCodeValidated,
  props<{ data: string }>()
);

export const UpdateVehicleDoors = createAction(GeneralActions.UpdateVehicleDoors, props<{ data: number }>());

export const UpdateRecommendations = createAction(
  GeneralActions.UpdateRecommendations,
  props<{ data: Recommendation }>()
);

export const UpdateQuotation = createAction(GeneralActions.UpdateQuotation, props<{ data: Quoting }>());

export const UpdateCarInsurers = createAction(
  GeneralActions.UpdateCarInsurers,
  props<{ data: QbItaParameterResult[] }>()
);
